define((require) => {
    "use strict";

    const {find}        = require("underscore");
    const ImprovedModel = require("shared/zbone/ImprovedModel");

    /**
     * Represents a specific locale, i.e. a country and a variant, provided as a 2-part locale string e.g. <tt>en-US</tt>.
     *
     * @class Locale
     * @author Kim
     */
    return ImprovedModel.extend("Locale", {

        defaults: {
            // The locale language code
            variant: null,

            // The country code
            country: null,

            // A given readable variant name for this locale
            localeString: null,

            variantName: null
        },

        /**
         * Constructor.
         *
         * @param  {String} localeString A 2-part locale string, e.g. <tt>en-US</tt>.
         * @param  {String} variantName  The display friendly name of the variant, e.g. <tt>American English</tt>.
         */
        constructor(localeString, variantName) {
            ImprovedModel.prototype.constructor.call(this);

            const parts = localeString.split("-");
            const variant = parts[0];
            const country = parts[1];

            this.set({
                variant,
                country,
                localeString,
                variantName
            }, {silent: true});
        },

        getCountry() {
            return this.get("country");
        },

        getVariant() {
            return this.get("variant");
        },

        getVariantName() {
            return this.get("variantName");
        },

        getLocaleString() {
            return this.get("localeString");
        },

        toString() {
            return this.getVariantName();
        },

        /**
         * Overwrites the toJSON from backbone, because a locale is mainly used as a value in LocalizationGroup.
         * when we save a LocalizationGroup, the backend expect locale to be a string instead of a JSON object.
         *
         * @returns {String} The locale string, e.g. <tt>en-US</tt>
         */
        toJSON() {
            return this.getLocaleString();
        },

        /**
         * The unique identifier represents this Locale.
         *
         * @returns {String} The locale string, e.g. <tt>en-US</tt>
         */
        getIdentifier() {
            return this.get("localeString");
        }
    }, {

        /**
         * Returns the correct locale string from the given model.
         *
         * @param {ImprovedModel} model from where to extract the local information.
         * @returns {String} The locale string.
         */
        localeStringFromModel(model) {
            const group = model.get("group");
            const found = find(group.entries, (entry) => entry.reference && entry.reference.resourceId === model.get("id"));

            if (found) {
                return `(${found.value.split("-")[1]})`;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/services/localization/Locale.js